export const PDF_PREVIEW_MAX_BYTES = 32 * 1024 * 1024;
export const PDF_CUTLINE_PREVIEW_MAX_BYTES = 8 * 1024 * 1024;
export const PDF_PREVIEW_MAX_PIXELS = 2_000_000;

export function pdfPreviewScale(width: number, height: number) {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) throw new Error('Invalid PDF page dimensions');
  return Math.min(2, 2048 / Math.max(width, height), Math.sqrt(PDF_PREVIEW_MAX_PIXELS / (width * height)));
}

export function mayExtractPreviewCutline(fileSize?: number) {
  return typeof fileSize === 'number' && fileSize > 0 && fileSize <= PDF_CUTLINE_PREVIEW_MAX_BYTES;
}
